module.exports = __webpack_public_path__ + "img/warehouse-2.add59225.jpg";